import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

// Codice a barre della carta: EAN-13 se il numero è di 13 cifre, altrimenti CODE128 (formato storico "W…")
export default function CardBarcode({ value, height = 64, className = "", testid = "card-barcode" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !value) return;
    const ean = /^\d{13}$/.test(value);
    try {
      JsBarcode(ref.current, value, { format: ean ? "EAN13" : "CODE128", height, width: ean ? 2 : 1.6, displayValue: true, fontSize: 13, font: "ui-monospace, monospace", margin: 6, background: "#ffffff", lineColor: "#111111" });
    } catch (e) { /* valore non codificabile: lascia vuoto */ }
  }, [value, height]);
  if (!value) return null;
  return <svg ref={ref} className={`mx-auto max-w-full rounded-xl bg-white ${className}`} data-testid={testid} aria-label={`Codice a barre ${value}`} />;
}
